import omit from 'lodash/omit'
import pick from 'lodash/pick'
import map from 'lodash/map'

const commonReducers = INITIAL_STATE => ({
  updateState(state, { payload }) {
    return {
      ...state,
      ...payload,
    }
  },
  removeState(state, { payload }) {
    const newState = omit(state, payload)
    return {
      ...newState,
    }
  },
  initializeState(state, { payload }) {
    const initialStates = pick(INITIAL_STATE, payload)
    return {
      ...state,
      ...initialStates,
    }
  },
  initializeAll(state, { payload }) {
    let newState = {}
    if (payload) {
      newState = omit(INITIAL_STATE, payload)
    } else {
      newState = INITIAL_STATE
    }

    return {
      ...state,
      ...newState,
    }
  },
})

export default model => {
  const { namespace, state: modelState = {}, effects = [], reducers = {} } = model

  return {
    namespace,
    // eslint-disable-next-line default-param-last
    reducers: (state = modelState, action) => {
      if (!action.type || !action.type.includes(namespace)) {
        return state
      }

      const fullReducers = { ...reducers, ...commonReducers(modelState) }

      const enhanceReducer = {}
      map(fullReducers, (r, l) => {
        enhanceReducer[`${namespace}/${l}`] = e => r(e, action)
      })

      return enhanceReducer[action.type]
        ? enhanceReducer[action.type](state, action.payload)
        : state
    },
    effects: [
      ...map(effects, (effect, effectLbl) => ({
        effectLbl: `${namespace}/${effectLbl}`,
        effect,
      })),
    ],
  }
}
